import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberInputLegacy]',
})
export class NumberInputLegacyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: KeyboardEvent) {
    const initialValue = this.el.nativeElement.value;

    // Allow digits (0-9) and a decimal point (,).
    this.el.nativeElement.value = initialValue.replace(/[^0-9,]*/g, '');

    // Allow only two decimal places
    const parts = this.el.nativeElement.value.split(',');
    if (parts.length > 2) {
      this.el.nativeElement.value = parts[0] + ',' + parts[1].slice(0, 2);
    }

    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {}
}
